import { Icon, type IconProps, Box } from "@chakra-ui/react";
import React from "react";

export function CheckIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" fill="none" viewBox="0 0 24 24" {...props}>
      <Box
        as="path"
        fill="currentColor"
        fillRule="evenodd"
        d="M19.707 6.493a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L9 15.786l9.293-9.293a1 1 0 0 1 1.414 0Z"
        clipRule="evenodd"
      />
    </Icon>
  );
}
